module.exports = __webpack_public_path__ + "static/media/Farmers-on-the-frontline-mobile.f48089b9.jpg";